<template>
  <div
    v-if="!pulseUser && latestChangelog"
    class="sf-row sf-bg-snow-dark sf-pad-2"
  >
    <div class="sf-col">
      <div class="sf-level sf-level-center">
        <div class="sf-pad-r-6">
          <span class="sf-label sf-label-primary">{{ label }}</span>
          <span class="sf-fwdb sf-font-m sf-pad-l-2">{{
            latestChangelog
          }}</span>
        </div>

        <div>
          <a
            :href="changelogUrl"
            target="_blank"
            class="sf-a sf-a-primary sf-fwdb"
            @mouseup="markAsRead"
            >{{ I18n.t('shared.read_more') }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  computed: mapState({
    hasNewChangelog: 'hasNewChangelog',
    latestChangelog: 'latestChangelog',
    pulseUser: 'pulseUser',

    label: (state) => {
      if (state.hasNewChangelog) {
        return state.changelogCategory
      } else {
        return 'Changelog'
      }
    },

    ...mapGetters(['changelogUrl']),
  }),

  created() {
    this.updateChangelog()
  },

  methods: {
    ...mapActions(['updateChangelog', 'markAsRead']),
  },
}
</script>
